module.exports = __webpack_public_path__ + "img/SONIC-584x584.a3e68883.webp";